<template>
  <div class="home-content">
     <div class="box-content">
        <div class="column"> 
          <div class="project-info">
            <div class="title">项目信息</div>
            <div class="module-1-1">
              <p class="flex" style="height: 4vh;line-height: 4vh;">
                <span class="width-span">项目名称</span>：
                <span class="nowrap">{{projectInfo.name}}</span>
              </p>
              <p class="flex" style="height: 4vh;line-height: 4vh;">
                <span class="width-span">项目地址</span>：
                <span class="nowrap">{{projectInfo.address}}</span>
              </p>
            </div>
              <div class="module-1-1">
              <p class="flex" style="height: 4vh;line-height: 4vh;">
                <span class="width-span">建设单位</span>：
                <span class="nowrap">{{participatingUnits.workName[0]}}</span>
              </p>
              <p class="flex" style="height: 4vh;line-height: 4vh;">
                <span class="width-span">建设单位负责人</span>：
                <span>{{participatingUnits.workingManager[0]}}</span>
              </p>
            </div>
              <div class="module-1-1">
              <p class="flex" style="height: 4vh;line-height: 4vh;">
                <span class="width-span">施工单位</span>：
                
                <span>{{participatingUnits.buildingName[0]}}</span>
              </p>
              <p class="flex" style="height: 4vh;line-height: 4vh;">
                <span class="width-span">项目经理</span>：
                
                <span>{{participatingUnits.buildingManager[0]}}</span>
              </p>
            </div>
            <div class="module-1-1">
              <p class="flex" style="height: 4vh;line-height: 4vh;">
                <span class="width-span">监理单位</span>：
                <span class="nowrap">{{participatingUnits.checkName[0]}}</span>
              </p>
              <p class="flex" style="height: 4vh;line-height: 4vh;">
                <span class="width-span">监理工程师</span>：
                <span>{{participatingUnits.checkManager[0]}}</span>
              </p>
            </div>
            <div class="module-1-2">
              <div class="schedule-title">
                <span style="color: #333;">预计进度</span>
                <span>倒计时 {{projectInfo.countDownDay}} 天</span>
              </div>
              <div class="schedule">
                <el-progress :percentage="projectInfo.progress" :stroke-width="18"></el-progress>
                <div style="display: flex;justify-content: space-between;margin-top: 1vh;">
                  <p>{{projectInfo.startDate}}</p>
                  <p>{{projectInfo.endDate}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="team-attendance">
            <div class="title">班组出勤</div>
            <div class="table">
              <div :class="{anim1:animate1==true}">
                  <p class="table-tr" v-for="(item,index) in attendTeam" :key="index">
                  <span class="nowrap">{{item.teamsName}}</span>
                  <span>在职 {{item.zzCount}}人</span>
                  <span>出勤 {{item.cqCount}}人</span>
                  <span>出勤率 {{item.lv}}%</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
           <div class="today-attendance">
             <div class="title">今日出勤</div>
             <div class="person">
               <div>
                   <div class="num">
                  <p
                      :class="{'number-item': !isNaN(item) }"
                      v-for="(item,index) in numLen1"
                      :key="index"
                  >
                      <span v-if="!isNaN(item)">
                        <i ref="numberItem1">0123456789</i>
                      </span>
                      <span v-else>{{item}}</span>
                  </p>
                </div>
                <div style="text-align: center;">管理人员</div>
               </div>
                   <div>
                   <div class="num">
                  <p
                      :class="{'number-item': !isNaN(item) }"
                      v-for="(item,index) in numLen2"
                      :key="index"
                  >
                      <span v-if="!isNaN(item)">
                      <i ref="numberItem2">0123456789</i>
                      </span>
                      <span v-else>{{item}}</span>
                  </p>
                </div>
                <div style="text-align: center;">建筑工人</div>
               </div>
                   <div>
                   <div class="num">
                  <p
                      :class="{'number-item': !isNaN(item) }"
                      v-for="(item,index) in numLen3"
                      :key="index"
                  >
                      <span v-if="!isNaN(item)">
                      <i ref="numberItem3">0123456789</i>
                      </span>
                      <span v-else>{{item}}</span>
                  </p>
                </div>
                <div style="text-align: center;">特种人员</div>
               </div>
             </div>
             <div style="display: flex;justify-content: space-between;align-items: center;padding: 0 1vw;height: 6vh;">
               <span>共计：{{attendPerson.allNowCount || 0}} 人</span>
               <span>出勤率：{{attendPerson.countRate || 0}}%</span>
             </div>
           </div>
            <div class="ankang-code">
              <div class="title">健康码监测</div>
              <div class="fourMa">
                <div style="background-color: #d9d9d9;">
                  <span>{{anKang.noAnKang}}</span>
                  <span>异常灰码</span>
                </div>
                <div style="background-color: #04b780;">
                  <span>{{anKang.green}}</span>
                  <span>正常绿码</span>
                </div>
                <div style="background-color: #e6ca23;">
                  <span>{{anKang.yellow}}</span>
                  <span>异常黄码</span>
                </div>
                <div style="background-color: #d93906;">
                  <span>{{anKang.red}}</span>
                  <span>危险红码</span>
                </div>
              </div>
               <div ref="chart2" style="width: 100%;height: 32vh;"></div>
            </div>
        </div>
      
      <div class="column">
         <div class="person-number">
           <div class="title">在场人员</div>
           <div ref="chart1" style="width: 100%;height: 30vh;"></div>
           <div style="display: flex;justify-content: space-between;position: absolute;bottom: 2.5vh;left: 1vw;width: 94%;">
             <p>共计：{{presentPerson.allNowCount}}人</p>
             <p>出勤率：{{presentPerson.countRate}}%</p>
           </div>
         </div>
         <div class="key-position">
           <div class="title">关键岗位</div>
             <div class="table-key">
              <div :class="{anim2:animate2==true}">
                <p class="table-tr-key" v-for="(item,index) in keyPosition" :key="index">
                  <span style="width: 20%;text-align: left;">{{item.name}}</span>
                  <span style="width: 15%;">
                    <img :src="item.idcardPhoto" style="height:7vh;" />
                  </span>
                  <span style="width: 45%;">{{item.label}}</span>
                  <span>出勤率 {{item.csSum}}%</span>
                </p>
              </div>
            </div>
         </div>
      </div>
     </div>
  </div>
</template>

<script>
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  import base from '../../../untils/base'
  export default {
    data() {
      return {
        projectId: util.session.get('groupId'),
        numLen1: ['0'],
        numLen2: ['0'],
        numLen3: ['0'],
        projectInfo: {},   // 项目信息
        participatingUnits: [],    // 参建单位
        attendPerson: {},               //  今日出勤人员
        presentPerson: {},           // 在场人员
        attendTeam: [],              // 班组出勤
        anKang: {},           // 安康码
        keyPosition: [],         // 关键岗位
        timer1: undefined,
        animate1: false,
        timer2: undefined,
        animate2: false,
      }
    },
    created(){
      this.getProjectInfo()
      this.getUnits()
      this.getTeamAttend()
      this.getKeyPosition()
    },
    mounted() {
      if(this.timer1){
        window.clearInterval(this.timer1)
      }
      if(this.timer2){
        window.clearInterval(this.timer2)
      }
      this.getAttendPerson()
      this.getPresentPerson()
      this.getAnkangList()
    }, 
    watch: {
      '$store.state.groupId': function(val, old) {
        if(this.timer1){
            window.clearInterval(this.timer1)
        }
        if(this.timer2){
            window.clearInterval(this.timer2)
        }
      }
    },
    methods: {
      // 获取项目信息
      getProjectInfo(){
        myHttp.getProjectById({
          id: this.projectId
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            this.projectInfo = resp.data.data.project
            this.projectInfo.countDownDay = util.myTime.getdayByDate(util.myTime.getCurTime(), this.projectInfo.endDate)
            this.projectInfo.progress = parseInt(util.myTime.getdayByDate(this.projectInfo.startDate, util.myTime.getCurTime()) / (util.myTime.getdayByDate(this.projectInfo.startDate, this.projectInfo.endDate)) * 100)
            if(this.projectInfo.progress > 100){
              this.projectInfo.progress = 100
            }else if(this.projectId.progress < 0){
              this.projectInfo.progress = 0
            }
          }
        })
      },

      // 获取参建单位
      getUnits(){
        myHttp.getProjectMessByProjectId({
          projectId: this.projectId
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            this.participatingUnits = resp.data.data
          }
        })
      },

      // 获取今日出勤数据
      getAttendPerson(){
        myHttp.dayAttendance({
          projectId: this.projectId
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            const data = resp.data.data
            data.countRate = data.allTeamsCount && data.allTeamsCount!='0'?(parseInt(data.allNowCount)/parseInt(data.allTeamsCount)*100).toFixed(1):0
            this.attendPerson = data
            this.refreshAttendData(data.manageCount,this.$refs.numberItem1,1)
            this.refreshAttendData(data.workersCount,this.$refs.numberItem2,2)
            this.refreshAttendData(data.specialCount,this.$refs.numberItem3,3)
          }
        })
      },

      //整理今日出勤数据
      refreshAttendData(data,items,index){
          let len1 = data.toString().length
          if(index==1){
              this.numLen1 = []
              for(let i=0;i<len1;i++){
                  this.numLen1.push('0')
              }
          }else if(index==2){
              this.numLen2 = []
              for(let i=0;i<len1;i++){
                  this.numLen2.push('0')
              }
          }else if(index==3){
              this.numLen3 = []
              for(let i=0;i<len1;i++){
                  this.numLen3.push('0')
              }
          }
          console.log(items);
          setTimeout(() => {
              this.setNumberTransform(data,items)
          },100)
      },
      // 设置每一位数字的偏移
      setNumberTransform (num,items) {
        console.log(items);
          let numberItems = items
          let numberArr = (num+'').split('')
          for (let index = 0; index < numberItems.length; index++) {
              let elem = numberItems[index]
              elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`
          }
      },

      //  获取在场人员
      getPresentPerson(){
        myHttp.dayInAttendance({
          projectId: this.projectId
        }).then(resp => {
          if(resp.data.code === 200){
            const data = resp.data.data
            data.countRate = data.allTeamsCount && data.allTeamsCount!='0'?(parseInt(data.allNowCount)/parseInt(data.allTeamsCount)*100).toFixed(1):0
            this.presentPerson = data
            this.initChart1()
          }
        })
      },

      // 在场人员图表
      initChart1(){
        let myChart = this.$echarts.init(this.$refs.chart1)
        myChart.setOption({
          series: [
            {
              type: 'pie',
              radius: '80%',
              data: [
                {
                  name: '管理人员',
                  value: this.presentPerson.manageCount
                },
                {
                  name: '建筑工人',
                  value: this.presentPerson.workersCount
                },
                {
                  name: '特种人员',
                  value: this.presentPerson.specialCount
                }
              ],
              color: ['#6b99e5', '#2152a5', '#3a6dc2'],
              label: {
                normal: {
                  position: 'inner',
                  formatter: '{b}\n{c}人',
                  textStyle: {
                    color: '#fff'
                  }
                }
              }
            }
          ]
        })
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      },

      // 获取班组出勤
      getTeamAttend(){
        myHttp.getAttendNewHome({
          projectId: this.projectId,
          date:util.myTime.getCurTime()
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            const list = resp.data.data.list||[]
            for(let i=0;i<list.length;i++){
                list[i].lv = list[i].zzCount==0?'0.0':(parseInt(list[i].cqCount)/parseInt(list[i].zzCount)*100).toFixed(1)
            }
            this.attendTeam = list
            setTimeout(() => {
                this.timer1 = setInterval(this.scroll1,1300) // 班组考勤滚动
            },500)
          }
        })
      },

      //班组考勤列表滚动
      scroll1(){
        if(this.attendTeam.length>4){
          this.animate1=true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
          setTimeout(()=>{      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
              this.attendTeam.push(this.attendTeam[0]);
              this.attendTeam.shift();
              this.animate1 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
          },1000)
        }else{
          window.clearInterval(this.timer1)
        }
      },

      //  获取安康码数据
      getAnkangList(){
        myHttp.anKangCodeList({
          projectId: this.projectId
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            const data = resp.data.data
            data.noAnKang = data.registered - data.green - data.yellow - data.red
            this.anKang = data
            this.initChart2()
          }
        })
      },

      // 健康码图表
      initChart2(){
        let myChart = this.$echarts.init(this.$refs.chart2)
        myChart.setOption({
          title: {
            text: '今日入场总人数',
            subtext: this.anKang.registered + '人',
            top: '45%',
            left: 'center',
            textStyle: {
              fontSize: '18px'
            },
            subtextStyle: {
              fontSize: '18px',
              fontWeight: 900
            }
          },
          series: [
            {
              type:  'pie',
              radius: ['55%', '80%'],
              color: ['#04b780', '#e6ca23', '#d93906', '#d9d9d9'],
              label: {
                  formatter: '{b}{c}人',
                    textStyle: {
                      fontSize: 14
                    }
              },
              data: [
                {
                  name: '绿码',
                  value: this.anKang.green
                },
                {
                  name: '黄码',
                  value: this.anKang.yellow
                },
                {
                  name: '红码',
                  value: this.anKang.red
                },
                {
                  name: '入场',
                  value: this.anKang.noAnKang
                }
              ]
            }
          ]
        })
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      },

      //  获取关键岗位
      getKeyPosition(){
        myHttp.keyPosition({
          projectId: this.projectId
        }).then(resp => {
          if(resp.data.code === 200){
            const list = resp.data.data.list||[]
            for(var i=0;i<list.length;i++){
                list[i].idcardPhoto = list[i].idcardPhoto && list[i].idcardPhoto!=''?base.httpCtx+list[i].idcardPhoto:require('../../../assets/image/zanwutupian.png')
                list[i].csSum = (parseInt(list[i].csSum)/parseInt(new Date().getDate())*100).toFixed(0)
            }
            this.keyPosition = list
            setTimeout(() => {
                this.timer2 = setInterval(this.scroll2,1200) 
            },1000)
          }
        })
      },

      //关键岗位列表滚动
      scroll2(){
        if(this.keyPosition.length>4){
          this.animate2=true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
          setTimeout(()=>{      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
              this.keyPosition.push(this.keyPosition[0]);
              this.keyPosition.shift();
              this.animate2 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
          },1000)
        }else{
          window.clearInterval(this.timer2)
        }
      },

      // 去安康码
      // toAnKang(){
      //   this.$router.push({ path: '/newAnkang' })
      // }
    },
  }
</script>

<style scoped>
.home-content{
  /* height: 90vh; */
  padding: 1vh 1vw;
  overflow: auto;
}
.box-content{
  height: 100%;
  display: flex;
  margin-top: 1vh;
  flex-wrap: wrap;
  justify-content: space-between;
}
.column > div {
  background-color: #ffffff;
	box-shadow: 2px 2px 7px 0px 	rgba(105, 159, 204, 0.5);
	border-radius: 6px;
}
.column > div:nth-child(1){
  margin-bottom: 2vh;
}
.project-info{
  width: 32vw;
  height: 52vh;
}
.today-attendance, .person-number {
  position: relative;
  width: 32vw;
  height: 37vh;
}
.person-number{
  width: 31vw;
}
.team-attendance{
  width: 32vw;
  height: 31vh;
}
.ankang-code, .key-position{
  width: 32vw;
  height: 46vh;
}
.key-position{
  width: 31vw;
}
.column{
  display: flex;
  height: 100%;
  width: 32%;
  flex-direction: column;
  justify-content: space-between;
}
.title{
  text-align: left;
  padding: 1vh 1vw;
  color: #333;
  font-family: PingFang-SC-Bold;
  border-bottom: 1px solid #ecf0f5;
}
.flex{
  display: flex;

}
.width-span{
  display: inline-block;
  text-align-last: justify;
  width: 8vw;
}
.module-1-1{
  padding-left: 1vw;
  border-bottom: 1px solid #ecf0f5;
}
.module-1-2{
  width: 100%;
  padding: 0.8vh 1vw;
}
.schedule-title{
  display: flex;
  justify-content: space-between;
}
.table{
  height: 25vh;
  padding: 2px;
  overflow: hidden;
}
.table-tr{
  width: 100%;
  height: 6vh;
  padding: 0 2vw;
  display: flex;
  align-items: center;
  background-color: #f0f3f8;
  margin-bottom: 2px;
}
.table-tr > span {
  width: 25%;
  text-align: left;
}
.table-key{
  height: 40vh;
  padding: 2px;
  overflow: hidden;
}
.table-tr-key{
  width: 100%;
  height: 9.5vh;
  padding: 0 2vw;
  display: flex;
  align-items: center;
  background-color: #f0f3f8;
  margin-bottom: 2px;
}
 .table-tr-key > span{
  width: 25%;
  text-align: center;
 }
 .fourMa{
   height: 6vh;
   display: flex;
   justify-content: space-evenly;
   align-items: center;
   margin: 1vh 0;
 }
 .fourMa > div{
   display: flex;
   width: 6vw;
   height: 6vh;
   color: #fff;
   border-radius: 6px;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   /* cursor: pointer; */
 }

/* 数字滚动 */
.number-item{
  width: 2.4vw;
  height: 6.2vh;
  margin-bottom: 3vh;
}
.number-item span{
  position: relative;
  display: inline-block;
  margin-right: 10px;
  width: 100%;
  height: 100%;
  writing-mode: vertical-rl;
  text-orientation: upright;
  overflow: hidden;
}
.number-item i{
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%,0);
  transition: transform 1s ease-in-out;
  letter-spacing: 10px;
  font-size: 2.9vw;
}
.num{
  font-size: 1vw;
  width: 100%;
  position: relative;
  font-family: 'open_24_display_stregular';
  font-weight: 600;
  display: flex;
  justify-content: center;
  color: #1E369A;
}
.person{
  display: flex;
  justify-content: space-evenly;
  padding: 7vh 0;
  border-bottom: 1px solid #ecf0f5;
}
.schedule{
  width: 30vw;
  height: 10vh;
  padding-top: 3vh;
}
.project-info >>> .el-progress-bar__inner{
  background-image: linear-gradient(-88deg,	#2152a5 0%, #77a3ed 100%);
}
.popover-box{
  max-height: 30vh;
  overflow: auto;
}
.popover-box-input{
  border-bottom: 1px solid #ccc;
}
.popover-box-input-focus{
  border-bottom: 1px solid #409EFF;
}
.popover-box-content{
  max-height: 40vh;
  overflow: auto;
}
.popover-box-content-item{
  height: 5vh;
  text-align: center;
  line-height: 5vh;
  cursor: pointer;
}
.popover-box-content-item:hover{
  color: blue;
  background: rgba(64, 158, 255, 0.5);
}
.anim1{
  transition: all 1s;
  margin-top: -6vh;
}
.anim2{
  transition: all 1s;
  margin-top: -9.5vh;
}
.el-progress{
  display: flex;
}


.popover-box >>> .el-input__inner{
  border: none;
}
</style>
<style scoped>
@font-face{
  font-family: 'open_24_display_stregular';
  src: url('../../../assets/css/open_24_display_st-webfont.woff')
}
</style>